import { UseFormReturn } from 'react-hook-form'
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form'
import { Input } from '@/components/ui/input'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'

interface MediationConciliationFormProps {
  form: UseFormReturn<any>
  isView?: boolean
}

export function MediationConciliationForm({ form, isView }: MediationConciliationFormProps) {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="Adverse Party"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Adverse Party *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter adverse party name" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Address of Adverse Party"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Address of Adverse Party *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter address" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Scheduled Dates"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Scheduled Dates *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter scheduled dates" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Client"
        render={({ field }) => (
          <FormItem className="space-y-3">
            <FormLabel>Settlement Status *</FormLabel>
            <FormControl>
              <RadioGroup
                onValueChange={field.onChange}
                defaultValue={field.value}
                disabled={isView}
                className="flex flex-row space-x-6"
              >
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Settled" id="settled" />
                  <label htmlFor="settled" className="text-sm font-medium cursor-pointer">
                    Settled
                  </label>
                </div>
                <div className="flex items-center space-x-2">
                  <RadioGroupItem value="Not Settled" id="not-settled" />
                  <label htmlFor="not-settled" className="text-sm font-medium cursor-pointer">
                    Not Settled
                  </label>
                </div>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="Action Taken"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Action Taken *</FormLabel>
            <FormControl>
              <Input {...field} disabled={isView} placeholder="Enter action taken" />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  )
}
